<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <v-dialog v-model="dialog" max-width="800px">
            <v-card>
                <v-card-title>
                    <span class="headline">Edit Food Entry</span>
                </v-card-title>

                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex xs12>
                                <v-text-field :disabled="true" v-model="editedItem.fooddescription" label="Description"></v-text-field>
                            </v-flex>
                            <v-flex xs6>
                                <v-select :items="editedItem.measures" item-text="measurename" item-value="measureid" v-model="editedItem.portion_basis" label="Portion Basis"></v-select>
                            </v-flex>
                            <v-flex xs6>
                                <v-text-field v-model="editedItem.portion_multiplier" label="Portion Multiplier"></v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                    <v-btn color="blue darken-1" text @click="updateFood">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="saveIngredientDialog" max-width="800px">
            <MealAsFoodForm v-if="!meal" :loading.sync="loading" @snackbar="displaySnackbar" :dialog.sync="saveIngredientDialog" :foods="mealFood" title="Create new component" />
            <MealAsFoodForm v-else :loading.sync="loading" @snackbar="displaySnackbar" :dialog.sync="saveIngredientDialog" :meal="meal" :foods="selectedFood" title="Create new component" @refreshDay="$emit('refreshDay')" />
        </v-dialog>

        <v-dialog v-model="addIngredientDialog" max-width="1800px">
            <v-card>
                <FoodTable :dialog.sync="addIngredientDialog" @snackbar="displaySnackbar" :component="selectedComponent" :meal="meal ? meal.id : null" />
            </v-card>
        </v-dialog>

        <v-dialog v-model="selectMealVersionDialog" v-if="selectMealVersionDialog" max-width="800px">
            <v-card>
                <SelectMealVersion :mainMeal="selectedMeal" @close="selectMealVersionDialog = false" @getDayTotalNutrients="$emit('getDayTotalNutrients')"></SelectMealVersion>
            </v-card>
        </v-dialog>

        <div class="mb-2" v-for="(mealComponent, key) in mealComponentItems">
            <v-card flat class="flat-card">
                <v-card-title>
                    <div><h3 v-if="meal">{{ meal.name }} ({{mealComponent.name}}, id: {{ meal.id }})</h3><h3 v-else>{{mealComponent.name}}</h3></div>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="selectVersion(meal)">Select version</v-btn>
                    <v-btn @click="componentKey = key; addIngredientDialog = true" color="primary" class="white--text" text>Add ingredient<v-icon right dark>add</v-icon></v-btn>
                    <v-btn v-if="!mealComponent.id" @click="saveIngredientDialog = true" color="primary" class="white--text" :disabled="!mealFood || mealFood.length === 0" text>Save as component<v-icon right dark>save</v-icon></v-btn>
                    <v-btn v-if="!meal && mealComponent.id" @click="saveIngredientDialog = true" color="primary" class="white--text" :disabled="!mealFood || mealFood.length === 0" text>Update component<v-icon right dark>save</v-icon></v-btn>
                </v-card-title>
                <v-card-text class="px-0">
                    <v-btn @click="isMealDetailsDisplayed = true" v-if="!isMealDetailsDisplayed" color="primary" text small>Show details</v-btn>
                    <v-data-table
                            v-if="isMealDetailsDisplayed"
                            :loading="loading"
                            :headers="headers"
                            fixed-header
                            height="500"
                            hide-default-header
                            :sort-by="sortBy"
                            :sort-desc="sortDesc"
                            :items="mealComponent.data"
                            :items-per-page="-1"
                            hide-default-footer
                            class="elevation-0">

                        <template v-slot:header="{ props: { headers } }">
                            <thead>
                                <tr>
                                    <th
                                            v-for="header in headers"
                                            :key="header.text"
                                            :class="['column sortable', sortDesc ? 'desc' : 'asc', header.value === sortBy ? 'active' : '']"
                                            @click="changeSort(header.value)"
                                    >
                                        {{ header.text }}
                                    </th>
                                    <th v-for="(nutrient, key) in nutrients"
                                        :key="key"
                                        :class="['column sortable', sortDesc ? 'desc' : 'asc', `nutrients.${key}.value` === sortBy ? 'active' : '']"
                                        @click="changeSort(`nutrients.${key}.value`)">
                                        <span>
                                            <v-icon small v-show="!sortDesc && `nutrients.${key}.value` === sortBy">arrow_upward</v-icon>
                                            <v-icon small v-show="sortDesc && `nutrients.${key}.value` === sortBy">arrow_downward</v-icon>
                                            {{nutrient.nutrientname}}
                                        </span>
                                    </th>
                                </tr>
                            </thead>
                        </template>
                        <template v-slot:body="{ items }">
                            <tbody>
                                <tr @click="setEditedItem(item)" v-for="item in items" :key="item.name">
                                    <td class="justify-center align-center">
                                        <v-checkbox
                                                v-if="meal"
                                                v-model="selected"
                                                :value="item.foodid"
                                                hide-details
                                        ></v-checkbox>
                                    </td>
                                    <td class="justify-center layout px-0 align-center">
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on }">
                                                <v-icon
                                                        v-on="on"
                                                        class="mx-2 pl-2"
                                                        color="blue"
                                                        @click="editItem(item)"
                                                >
                                                    edit
                                                </v-icon>
                                            </template>
                                            <span>Edit item</span>
                                        </v-tooltip>
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on }">
                                                <v-icon
                                                        v-on="on"
                                                        class="mx-2"
                                                        color="red"
                                                        @click="deleteItem(item)"
                                                >
                                                    delete
                                                </v-icon>
                                            </template>
                                            <span>Delete item</span>
                                        </v-tooltip>
                                    </td>
                                    <td class="text-xs-left">{{ item.foodid }}</td>
                                    <td class="text-xs-left">{{ item.fooddescriptionsimple || item.fooddescription }}</td>
                                    <td class="text-xs-right">
                                        <v-edit-dialog
                                                lazy
                                                large
                                                save-text="Update"
                                                @save="updateFood(item)"
                                        >
                                            <div class="primary--text font-weight-bold">{{ getMeasureName(item) }}</div>
                                            <div slot="input" class="mt-3 title">Update Portion basis</div>
                                            <v-select slot="input" :items="item.measures" item-text="measurename" item-value="measureid" v-model="item.portion_basis" label="Portion Basis"></v-select>
                                        </v-edit-dialog>
                                    </td>

                                    <td class="text-xs-right">
                                        <v-edit-dialog
                                                :return-value.sync="item.portion_multiplier"
                                                lazy
                                                @save="updateFood(item)"
                                        >
                                            <div class="primary--text font-weight-bold">{{ item.portion_multiplier }}</div>
                                            <div slot="input" class="mt-3 title">Update Portion Multiplier</div>
                                            <v-text-field
                                                    slot="input"
                                                    :value="item.portion_multiplier"
                                                    :rules="[max10chars]"
                                                    label="Edit"
                                                    single-line
                                                    counter
                                                    autofocus
                                            ></v-text-field>
                                        </v-edit-dialog>
                                    </td>
                                    <td>{{ getFoodWeight(item) }}g</td>

                                    <template v-for="(nutrient, key) in nutrients">
                                        <td>{{getNutrientAmount(item, key)}}</td>
                                    </template>
                                </tr>
                            </tbody>
                        </template>
                        <template slot="no-data">
                            <v-alert :value="true" color="error" icon="warning" outlined>
                                Please select ingredients from the ingredient list or the meal list
                            </v-alert>
                        </template>
                        <template slot="footer">
                            <td :colspan="headers.length">
                                <strong>Total weight: {{totalWeight}}g</strong>
                            </td>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </div>
        <v-card flat class="flat-card mb-4">
            <v-data-table
                    v-if="isMealDetailsDisplayed"
                    :items="[{}]"
                    hide-default-footer
            >
                <template v-slot:header="{ props: { headers } }">
                    <thead>
                        <tr style="background-color: aliceblue">
                            <th v-for="(_, key) in totalNutrients"
                                :key="key"
                                class="column">
                                <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                        <span v-on="on">{{nutrients[key].nutrientsymbol}}({{nutrients[key].unit}})</span>
                                    </template>
                                    <span>{{nutrients[key].nutrientname}}</span>
                                </v-tooltip>
                            </th>
                        </tr>
                    </thead>
                </template>
                <template v-slot:body="{ items }">
                    <tbody>
                        <tr v-for="item in items" :key="item.name">
                            <td :key="key" :class="totalNutrients[key] ? totalNutrients[key].color : ''" v-for="(_, key) in totalNutrients">
                                <span v-if="totalNutrients[key]">{{totalNutrients[key].value}}</span>
                                <span v-else>0.000</span>
                                <span v-if="totalNutrients[key] && totalNutrients[key].percent"> ({{totalNutrients[key].percent}}%)</span>
                            </td>
                        </tr>
                    </tbody>
                </template>
            </v-data-table>
        </v-card>

        <v-snackbar
                v-model="snackbar"
                :timeout="timeout"
                :color="snackbarColor"
                top
        >
            <strong>{{ snackbarText }}</strong>
            <v-btn
                    color="white"
                    text
                    @click="snackbar = false"
            >
                Close
            </v-btn>
        </v-snackbar>
    </div>
</template>

<script>
  import MealAsFoodForm from './MealAsFoodForm';
  import SelectMealVersion from './SelectMealVersion';
  import FoodService from '../../services/FoodService';
  import { mapGetters } from 'vuex';
  import SaveAsMealForm from './SaveAsMealForm';
  import FoodTable from '../FoodTable';

  export default {
    components: {FoodTable, SaveAsMealForm, MealAsFoodForm, SelectMealVersion},
    data: () => ({
      isMealDetailsDisplayed: false,
      loading: false,
      dialog: false,
      saveIngredientDialog: false,
      addIngredientDialog: false,
      selectMealVersionDialog: false,
      selectedMeal: null,
      snackbar: false,
      snackbarText: '',
      snackbarColor: '',
      selected: [],
      timeout: 4000,
      editDialog: false,
      valid: false,
      max10chars: (v) => v.toString().length <= 10 || 'Input too long!',
      headers: [
        {sortable: false},
        {sortable: false},
        {
          text: 'ID',
          align: 'left',
          value: 'foodid',
          sortable: false
        },
        { text: 'Description', value: 'fooddescription', sortable: false },
        { text: 'Portion basis', value: 'portion_basis_text', align: 'left', sortable: false },
        { text: 'Portion multiplier', value: 'portion_multiplier', align: 'left', sortable: false },
        { text: 'Weight', value: 'weight', align: 'left', sortable: true }
      ],
      sortBy: '',
      sortDesc: '',
      pagination: {
        sortBy: 'fooddescription'
      },
      editedIndex: -1,
      editedItem: {
        foodid: 0,
        fooddescription: '',
        portion_basis: '',
        portion_basis_text: '',
        portion_multiplier: '',
        measures: []
      },
      measures: [],
      name: null,
      description: null,
      componentKey: null,
      mealComponentItems: [],
      totalNutrients: {}
    }),
    props: {
      diet: Number,
      foods: Array,
      meal: Object
    },
    watch: {
      mealFood: {
        immediate: 'true',
        handler() {
          this.getMealComponentItems();
          this.getTotalNutrients();
        }
      }
    },
    methods: {
      async editItem(item) {
        try {
          this.loading = true;
          this.editedIndex = this.mealFood.indexOf(item);
          this.editedItem = Object.assign({}, item);
          const response = await FoodService.getMeasures(item.foodid);
          this.measures = response.data;
          this.dialog = true;
        } catch (e) {
          this.displaySnackbar(e.message, 'error');
        } finally {
          this.loading = false;
        }
      },
      setEditedItem(item) {
        this.editedIndex = this.mealFood.indexOf(item);
        this.editedItem = Object.assign({}, item);
      },
      async editMultiplier() {
        try {
          this.loading = true;
          this.editedIndex = this.mealFood.indexOf(item);
          this.editedItem = Object.assign({}, item);
          const response = await FoodService.getMeasures(item.foodid);
          this.measures = response.data;
          this.dialog = true;
        } catch (e) {
          this.displaySnackbar(e.message, 'error');
        } finally {
          this.getTotalNutrients();
          this.loading = false;
        }
      },
      deleteItem(item) {
        const index = this.mealFood.indexOf(item);
        this.mealFood.splice(index, 1);
        if (this.meal) {
            item.toRemove = true;
            this.$store.dispatch('updateDayFood', item);
        }
        this.getMealComponentItems();
        this.getTotalNutrients();
      },
      close() {
        this.dialog = false;
      },
      changeSort(column) {
        if (this.sortBy === column) {
          this.sortDesc = !this.sortDesc;
        } else {
          this.sortBy = column;
          this.sortDesc = false;
        }
      },
      updateFood(data) {
        const measure = data.measures.find((item) => data.portion_basis === item.measureid);
        if (measure) {
          data.conversion_factor = measure.conversionfactorvalue;
          data.portion_basis = measure.measureid;
        }
        if (this.foods) {
            this.$store.dispatch('updateDayFood', {food: data});
        } else {
            this.$store.dispatch('updateFood', {index: this.editedIndex, food: data});
        }
        this.getMealComponentItems();
        this.$nextTick(this.getTotalNutrients);
        this.dialog = false;
      },
      getMeasureName(item) {
        if (!item.portion_basis) {
          return '';
        }
        const measure = item.measures.find((data) => item.portion_basis.toString() === data.measureid.toString());
        if (measure) {
          return measure.measurename;
        } else {
          return `measure id ${item.portion_basis} is not valid, will default to 100g`;
        }
      },
      getNutrientAmount(item, key) {
        const nutrient = item.nutrients[key];
        if (!nutrient) {
          return '0.000';
        }
        if (!item.conversion_factor) {
          const measure = item.measures.find((data) => item.portion_basis === data.measureid);
          if (measure) {
            item.conversion_factor = measure.conversionfactorvalue;
          }
        }
        const multiplier = item.portion_multiplier || 1;
        const conversionFactor = item.conversion_factor || 1;
        const value = nutrient.value * multiplier * conversionFactor;
        return value.toFixed(3);
      },
      displaySnackbar(msg, color) {
        this.snackbarText = msg;
        this.snackbarColor = color;
        this.snackbar = true;
      },
      getFoodWeight(item) {
        if (!item.conversion_factor) {
          const measure = item.measures.find((data) => item.portion_basis === data.measureid);
          if (measure) {
            item.conversion_factor = measure.conversionfactorvalue;
          }
        }
        const multiplier = item.portion_multiplier || 1;
        const conversionFactor = item.conversion_factor || 1;
        return (multiplier * conversionFactor * 100).toFixed(2);
      },
      getMealComponentItems() {
        const components = {};
        let component = null;
        if (this.mealFood) {
          for (const food of this.mealFood) {
            if (food.component) {
              component = this.mealComponents.find((item) => item.id.toString() === food.component.toString());
              if (component) {
                components[food.component] = components[food.component] || {};
                components[food.component].name = component.name;
                components[food.component].description = component.description;
                components[food.component].id = food.component;
                components[food.component].data = components[food.component].data || [];
                components[food.component].data.push(food);
              }
            }
            if (!food.component || !component) {
              components.other = components.other || {};
              components.other.name = 'General ingredients';
              components.other.data = components.other.data || [];
              components.other.data.push(food);
            }
          }
        }
        this.mealComponentItems = components;
      },
      getTotalNutrients() {
        const total = {};
        for (const food of this.mealFood) {
          const measure = food.measures.find((item) => item.measureid === food.portion_basis);
          const multiplier = parseFloat(food.portion_multiplier || 1);
          const conversionFactor = parseFloat((measure ? measure.conversionfactorvalue : 1) || 1);
          for (const key in food.nutrients) {
            if (food.nutrients.hasOwnProperty(key)) {
              total[key] = total[key] || {
                value: 0.0
              };

              const value = parseFloat(food.nutrients[key].value || 0);

              total[key].value = (parseFloat(total[key].value) +
                parseFloat(value * multiplier * conversionFactor)).toFixed(3);
              if (this.targetsObj[key]) {
                total[key].percent =
                  (parseFloat(total[key].value) / this.targetsObj[key].target_value * 100).toFixed(1);
              }
            }
          }
        }
        this.totalNutrients = total;
      },
      selectVersion(meal) {
        this.selectedMeal = meal;
        this.selectMealVersionDialog = true;
      }
    },
    computed: {
      ...mapGetters({
        nutrients: 'getNutrients',
        targets: 'getTargets',
        diets: 'getDiets',
        mealComponents: 'getMealComponents'
      }),
      mealFood() {
        return this.foods || this.$store.getters.getMealFood;
      },
      selectedFood() {
        const foods = [];
        for (const id of this.selected) {
          const food = this.mealFood.find((item) => item.foodid === id);
          foods.push(food);
        }
        return foods;
      },
      selectedDiet() {
        return this.diets.find((item) => item.id === this.diet) ;
      },
      selectedComponent() {
        return this.mealComponentItems[this.componentKey] ? this.componentKey : null;
      },
      targetsObj() {
        const targets = {};
        if (this.targets && this.targets[this.diet]) {
          for (const target of this.targets[this.diet]) {
            targets[target.nutrient_id] = target;
          }
        }
        return targets;
      },
      totalWeight() {
        let total = 0;
        for (const food of this.mealFood) {
          const measure = food.measures.find((item) => item.measureid === food.portion_basis);
          const multiplier = parseFloat(food.portion_multiplier || 1);
          const conversionFactor = parseFloat((measure ? measure.conversionfactorvalue : 1) || 1);

          total += multiplier * conversionFactor * 100;
        }
        return total.toFixed(0);
      }
    }
  };
</script>

<style>

</style>
